<button
  mat-button
  [matMenuTriggerFor]="menu"
  class="flex items-center gap-2 rounded-full px-3 py-1"
  [ngClass]="{ 'text-warn-600': low, 'text-red-600': none }"
  type="button"
>
  <mat-icon class="icon-size-5" svgIcon="heroicons_outline:ticket"></mat-icon>

  <span class="text-sm font-medium">
    {{ resumen ? (totalDisponibles | number) : '—' }}
  </span>

  <span class="text-xs text-secondary hidden sm:inline">timbres</span>
</button>

<mat-menu #menu="matMenu" class="min-w-[360px]">
  <div class="px-4 py-3">
    <div class="flex items-start justify-between gap-3">
      <div>
        <div class="text-sm font-semibold">Timbres disponibles</div>
        <div class="text-xs text-secondary">Resumen por tipo</div>
      </div>

      <button mat-icon-button type="button" (click)="refresh()">
        <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
      </button>
    </div>

    @if (isLoading) {
      <div class="mt-3">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }

    @if (lastError) {
      <div class="mt-3 rounded-xl border border-warn-200 bg-warn-50 px-3 py-2 text-xs text-warn-700">
        {{ lastError }}
      </div>
    }

    <!-- Total -->
    <div class="mt-4 rounded-2xl bg-default-50 p-4 flex items-center justify-between">
      <div>
        <div class="text-[11px] text-secondary">Total disponibles</div>
        <div class="mt-1 text-2xl font-semibold">{{ resumen?.totalDisponibles ?? '—' }}</div>
      </div>

      <mat-icon
        class="icon-size-6"
        [ngClass]="{ 'text-red-600': none, 'text-warn-600': low && !none, 'text-secondary': !low && !none }"
        [svgIcon]="none ? 'heroicons_outline:x-circle' : low ? 'heroicons_outline:exclamation-triangle' : 'heroicons_outline:check-circle'"
      ></mat-icon>
    </div>

    <!-- Por tipo -->
    <div class="mt-4">
      <div class="mb-2 text-xs font-semibold text-secondary">Por tipo</div>

      @if (!(resumen?.tipos?.length)) {
        <div class="rounded-xl border border-dashed p-4 text-sm text-secondary">
          Sin datos por tipo.
        </div>
      } @else {
        <div class="divide-y rounded-2xl border">
          <div
            *ngFor="let t of tiposOrdenados; trackBy: trackByTipo"
            class="flex items-center justify-between px-4 py-3"
          >
            <div class="min-w-0">
              <div class="truncate text-sm font-medium">{{ tipoLabel(t.tipo) }}</div>
              <div class="text-xs text-secondary">
                Consumidos: <span class="font-medium text-default">{{ t.consumidos }}</span>
              </div>
            </div>

            <div class="text-right">
              <div class="text-sm font-semibold">{{ t.disponibles }}</div>
              <div class="text-[11px] text-secondary">disponibles</div>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Alertas -->
    @if (none) {
      <div class="mt-3 rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
        Sin timbres disponibles. No podrás validar/timbrar hasta recargar.
      </div>
    } @else if (low) {
      <div class="mt-3 rounded-xl border border-warn-200 bg-warn-50 px-3 py-2 text-xs text-warn-700">
        Saldo bajo (≤ {{ lowThreshold }}). Considera recargar.
      </div>
    }
  </div>
</mat-menu>